export default "__VITE_ASSET__Cg9lQlhF__"